import * as React from "react";
import { WatchedLogEntity, dayjs } from "src/common";

type AllProps = {
    entry: WatchedLogEntity
}

function ChangeRowComponent(props: AllProps) {
    const { entry } = props;

    return <div>
        <p>{dayjs(entry.last_modification_date).format("MMMM D, YYYY h:mm A")}</p>
        <p>{entry.user_id} {entry.event} <b>{entry.name}</b></p>
    </div>;

}

export default React.memo(ChangeRowComponent);